import { Component } from '@angular/core';

@Component({
  selector: 'lns-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent {
  currentYear: Date = new Date();
}
